import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { useAuth } from "../context/AuthContext";

export default function DevLoginPage() {
  const navigate = useNavigate();
  const { isLoggedIn, isPro, role, loading: authLoading } = useAuth();
  const [email, setEmail] = useState("254790338305@jirani.app");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [awaitingAuth, setAwaitingAuth] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");

    const { error } = await supabase.auth.signInWithPassword({
      email: email.trim(),
      password,
    });

    setSubmitting(false);

    if (error) {
      setError(error.message);
      return;
    }

    // Don't navigate yet — wait for AuthContext's own state to catch up.
    setAwaitingAuth(true);
  };

  // Once AuthContext has processed the sign-in (its onAuthStateChange
  // listener has resolved and fetchProfile has completed), navigate
  // based on ITS role, not a separately-fetched one.
  useEffect(() => {
    if (!awaitingAuth || authLoading) return;
    if (!isLoggedIn) return; // still settling

    if (isPro) navigate("/pro/dashboard");
    else if (role === "admin") navigate("/admin");
    else if (role === "client") navigate("/business/account");
    else navigate("/");
  }, [awaitingAuth, authLoading, isLoggedIn, isPro, role, navigate]);

  const loading = submitting || awaitingAuth;

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", background: "#f7f8fa", fontFamily: "sans-serif",
    }}>
      <form onSubmit={handleSubmit} style={{
        background: "#fff", padding: "32px 28px", borderRadius: 14,
        boxShadow: "0 8px 30px rgba(0,0,0,0.08)", width: 320,
      }}>
        <h2 style={{ margin: "0 0 6px", fontSize: 18 }}>Dev login</h2>
        <p style={{ margin: "0 0 20px", fontSize: 12.5, color: "#888" }}>
          Email/password bypass for testing. Not for production use.
        </p>

        <label style={{ display: "block", fontSize: 12.5, marginBottom: 6 }}>Email</label>
        <input
          type="email" value={email} onChange={(e) => setEmail(e.target.value)}
          required
          style={{ width: "100%", padding: "10px 12px", marginBottom: 14, borderRadius: 8, border: "1px solid #ddd", boxSizing: "border-box" }}
        />

        <label style={{ display: "block", fontSize: 12.5, marginBottom: 6 }}>Password</label>
        <input
          type="password" value={password} onChange={(e) => setPassword(e.target.value)}
          required
          style={{ width: "100%", padding: "10px 12px", marginBottom: 16, borderRadius: 8, border: "1px solid #ddd", boxSizing: "border-box" }}
        />

        {error && (
          <p style={{ fontSize: 12.5, color: "#c53030", marginBottom: 14 }}>{error}</p>
        )}

        <button
          type="submit" disabled={loading}
          style={{
            width: "100%", padding: "11px 0", borderRadius: 999, border: "none",
            background: "#1e9254", color: "#fff", fontWeight: 600, cursor: "pointer",
            opacity: loading ? 0.7 : 1,
          }}
        >
          {submitting ? "Signing in..." : awaitingAuth ? "Loading dashboard..." : "Sign in"}
        </button>
      </form>
    </div>
  );
}